import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
export const VerticalFlashlightIcon = ({ color, ...props }) => {
    const theme = useTheme();
    return (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2H18V9L16 12V21C16 21.5523 15.5116 22 14.9091 22H9.09091C8.48843 22 8 21.5523 8 21V12L6 9V2ZM10 11V20H14V11L16 8H8L10 11ZM8 4H16V7H8V4Z", fill: color ?? theme.colors.white }) }));
};
//# sourceMappingURL=vertical_flashlight_icon.js.map